import * as React from "react";
import {SELECT_BORDER_BOX, SelectStyles} from "../../../components/common/etui_components_styles";
import {equipmentsStatusesToSelectInputOption} from "../MassiveActionsTypesAndFunctions";
import {SelectInputOption} from "@vebox/etui-core";
import {
    ProcessStage,
    ProcessStageArrow,
    ProcessStageArrowDirection,
    ProcessStageOrder,
    useProcessController
} from "../../Processes";
import {VeboxForm} from "../../../components/form/VeboxForm";
import {DATA_STATE} from "../../../users/contexts/UsersDashboardContext";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {FormCardFooter} from "../../common";
import {ChangeEquipmentStatusContext} from "./ChangeEquipmentStatusProvider";
import {Display} from "../../../components/Display";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {MassiveActionProcessState} from "../MassiveActionsProvider";

declare var AppTranslations: AppTranslations;

interface ChooseOperationAndReason {
    stepNumber: number
    stageOrder: ProcessStageOrder
    title: string
    cardTitle?: string
    operationTitle: string
    operationDescription: string
    massiveActionProcessState: MassiveActionProcessState
}

const SELECT_BORDER_BOX_WITH_MARGIN: SelectStyles = {
    ...SELECT_BORDER_BOX,
    root: {
        mb: 10,
    },
};

export const ChooseEquipmentStatus: React.FC<ChooseOperationAndReason> = ({
                                                                              cardTitle,
                                                                              title,
                                                                              stepNumber,
                                                                              stageOrder,
                                                                              operationDescription,
                                                                              operationTitle,
                                                                              massiveActionProcessState
                                                                          }) => {

    const translations = AppTranslations.massiveActions.changeEquipmentStatus
    const {equipmentsStatuses} = React.useContext(ChangeEquipmentStatusContext);
    const processController = useProcessController();

    const [values, setValues] = VeboxForm.useFormValueState<any>("changeEquipmentStatus");
    const [equipmentsStatusesList, setEquipmentsStatusesList] = React.useState<SelectInputOption[]>([]);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState<boolean>(false);


    const reset = () => {
        if (equipmentsStatusesList.length > 0) {
            updateValue("status", equipmentsStatusesList[0]);
        }
    }

    const updateValue = (name: "status", value: any) => {
        setValues(prevValues => {
            return {
                ...prevValues,
                [name]: value
            }
        })
    }

    React.useEffect(() => {
        if (equipmentsStatuses.equipmentsStatusesState === DATA_STATE.loaded) {
            const statuses: SelectInputOption[] = equipmentsStatusesToSelectInputOption(
                equipmentsStatuses.equipmentsStatuses);
            setEquipmentsStatusesList(statuses);
            updateValue("status", statuses[0]);
        }
    }, [equipmentsStatuses.equipmentsStatusesState])

    React.useEffect(() => {
        setIsButtonDisabled(!(values && values?.status))
    }, [values])

    React.useEffect(() => {
        if (massiveActionProcessState === MassiveActionProcessState.INITIAL) {
            reset()
        }
    }, [massiveActionProcessState])

    const goToNext = () => {
        processController.goTo(processController.position + 1)
    };

    return (
        <ProcessStage
            stepNumber={stepNumber}
            title={title}
            stageOrder={stageOrder}
        >
            <div className={"flx-row"}>
                <ProcessStageArrow stepNumber={stepNumber} direction={ProcessStageArrowDirection.BACKWARD}/>
                <VeBoxCard className={"form-card"}>
                    <Display isVisible={cardTitle !== undefined}>
                        <h2 className={"bold card-title"}>{cardTitle}</h2>
                    </Display>
                    <div className={"operation-container"}>
                        <VeboxForm.Section name={"changeEquipmentStatus"}>
                            <VeboxForm.SelectInput
                                label={translations.equipmentStatusLabel}
                                name={"status"}
                                options={equipmentsStatusesList}
                                styles={SELECT_BORDER_BOX_WITH_MARGIN}
                            />
                        </VeboxForm.Section>
                    </div>
                    <div className={"operation-description-container"}>
                        <h2 className={"bold"}>{operationTitle}</h2>
                        <p className={"operation-description"}>{operationDescription}</p>
                    </div>
                    <FormCardFooter
                        onReset={reset}
                        onNext={goToNext}
                        disabled={isButtonDisabled}
                    />
                </VeBoxCard>
                <ProcessStageArrow
                    stepNumber={stepNumber}
                    direction={ProcessStageArrowDirection.FORWARD}
                    visible={values?.status}
                />
            </div>
        </ProcessStage>
    )
}